export const dropletBlue = {
    dropletBlue100: '#f7f9fb',
    dropletBlue200: '#f1f6fa',
    dropletBlue300: '#e1f0fd',
    dropletBlue400: '#d2e8fc',
    dropletBlue500: '#c1def8',
    dropletBlue600: '#aed1f1',
    dropletBlue700: '#95c0e7',
    dropletBlue800: '#6ea8dc',
    dropletBlue900: '#5895ca',
    dropletBlue1000: '#4c89bd',
    dropletBlue1100: '#326fa2',
    dropletBlue1200: '#21384d',
    dropletBlueAccentContrast: '#ffffff',
    dropletBlueAccentSurface: '#f2f6fa',
};

export const dropletBlueAlpha = {
    dropletBlue100: 'rgba(40, 125, 210, 0.02)',
    dropletBlue200: 'rgba(19, 125, 210, 0.05)',
    dropletBlue300: 'rgba(171, 216, 255, 0.33)',
    dropletBlue400: 'rgba(2, 133, 252, 0.17)',
    dropletBlue500: 'rgba(2, 125, 235, 0.24)',
    dropletBlue600: 'rgba(1, 114, 217, 0.31)',
    dropletBlue700: 'rgba(2, 107, 201, 0.41)',
    dropletBlue800: 'rgba(0, 103, 195, 0.56)',
    dropletBlue900: 'rgba(0, 94, 175, 0.65)',
    dropletBlue1000: 'rgba(2, 89, 163, 0.7)',
    dropletBlue1100: 'rgba(1, 77, 141, 0.8)',
    dropletBlue1200: 'rgba(0, 26, 51, 0.87)',
    dropletBlueAccentContrast: '#ffffff',
    dropletBlueAccentSurface: 'rgba(239, 245, 250, 0.8)',
};

export const dropletBlueDark = {
    dropletBlue100: '#04121f',
    dropletBlue200: '#081a29',
    dropletBlue300: '#002850',
    dropletBlue400: '#003362',
    dropletBlue500: '#004170',
    dropletBlue600: '#004d7e',
    dropletBlue700: '#00598c',
    dropletBlue800: '#00669a',
    dropletBlue900: '#0073a8',
    dropletBlue1000: '#0080b6',
    dropletBlue1100: '#008dc4',
    dropletBlue1200: '#009ad2',
    dropletBlueAccentContrast: '#ffffff',
    dropletBlueAccentSurface: '#081a29',
};

export const dropletBlueDarkAlpha = {
    dropletBlue100: 'rgba(4, 18, 31, 0.01)',
    dropletBlue200: 'rgba(8, 26, 41, 0.04)',
    dropletBlue300: 'rgba(0, 40, 80, 0.11)',
    dropletBlue400: 'rgba(0, 51, 98, 0.18)',
    dropletBlue500: 'rgba(0, 65, 112, 0.24)',
    dropletBlue600: 'rgba(0, 77, 126, 0.31)',
    dropletBlue700: 'rgba(0, 89, 140, 0.38)',
    dropletBlue800: 'rgba(0, 102, 154, 0.45)',
    dropletBlue900: 'rgba(0, 115, 168, 0.7)',
    dropletBlue1000: 'rgba(0, 128, 182, 0.65)',
    dropletBlue1100: 'rgba(0, 141, 196, 0.83)',
    dropletBlue1200: 'rgba(0, 154, 210, 0.96)',
    dropletBlueAccentContrast: '#ffffff',
    dropletBlueAccentSurface: 'rgba(8, 26, 41, 0.5)',
};
